import React from "react";
import { useTranslation } from "react-i18next";
import newOfficeInside1 from "../assets/new-office-inside-1.jpg";
import newOfficeInside2 from "../assets/new-office-inside-2.jpg";
import newOfficeInside3 from "../assets/new-office-inside-3.jpg";

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about">
      <div className="about-heading">
        <h1>{t("about-us-heading")}</h1>
      </div>
      <div className="about-image-text-wrapper">
        <div className="about-image">
          <div className="about-images-grid">
            <img src={newOfficeInside1} alt="New Office Interior 1" className="about-img-grid" />
            <img src={newOfficeInside2} alt="New Office Interior 2" className="about-img-grid" />
            <img src={newOfficeInside3} alt="New Office Interior 3" className="about-img-grid" />
          </div>
        </div>
        <div className="about-text">
          <div className="about-p1">
            <p>{t("about-us-p1")}</p>
          </div>
          <div className="about-p2">
            <p>{t("about-us-p2")}</p>
          </div>
          <div className="about-p3">
            <p>{t("about-us-p3")}</p>
          </div>

          <div className="about-p4">
            <p>{t("about-us-p4")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
